import i18next, { PostProcessorModule } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
/* eslint-disable @typescript-eslint/no-var-requires */
import en from './en';
import es from './es';

const resources = {
  en,
  es,
};

const defaultConfig: any = {
  lng: process.env.LANGUAGE,
  fallbackLng: 'en',
  resources,
  ns: [
    'GENERAL',
    'DEVICE_FAQ',
    'WAITING_ROOM',
    'TECHNICAL_ISSUE',
    'DEVICE_SETTINGS',
    'DEVICE_ISSUE',
    'VIDEO_CALL',
    'CONTROL_BAR',
  ],

  defaultNS: 'GENERAL',

  keySeparator: false, // we do not use keys in form messages.welcome

  postProcess: ['orphan'],

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
};

/**
 * Inserts a unicode space (\u00A0) in between the last two words of the given
 * string.  If the string has one word, no change.
 */
const adoptOrphanText = (text: string) => {
  const splits = text.split(' ');
  if (splits.length > 1) {
    const wordsLen = splits[splits.length - 1].length + splits[splits.length - 2].length + 1;
    const wordsStart = text.length - wordsLen;
    const newEndText = text.substring(wordsStart).replace(' ', '\u00A0');
    return text.substring(0, wordsStart) + newEndText;
  } else {
    return text;
  }
};

const orphanPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'orphan',
  process: (value: string /*, key: string, options: TOptions, translator: any*/) => {
    return adoptOrphanText(value);
  },
};

interface Ii18nConfig {
  [name: string]: string;
}

// This throws errors on missing copy, suitable for testing
export const setupI18nForTesting = (extraConfig?: Ii18nConfig) => {
  i18next
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      ...defaultConfig,
      saveMissing: true,
      missingKeyHandler: (lng: string[], ns: string, key: string) => {
        throw new Error(`The following key is missing: ${key}, namespace: ${ns}`);
      },
      ...extraConfig,
    });

  return i18next.t.bind(i18next);
};

export const initI18n = () => {
  i18next
    .use(LanguageDetector)
    .use(orphanPostProcessor)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init(defaultConfig);

  return i18next;
};

export { default as checkTranslations } from './checkTranslations';
